import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-rupee', 'CurrencyRupee', [["path",{"d":"M18 5h-11h3a4 4 0 0 1 0 8h-3l6 6"}],["path",{"d":"M7 9l11 0"}]]);